const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20minimalist%20abstract%20portrait%20style%20visual%20with%20coral%20and%20amber%20soft%20shapes%2C%20modern%20clean%20design%2C%20user%20avatar%20aesthetic&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '影迷小陈',
    time: '3天前',
    content: '苹果视频真的太方便了，不用注册不用付费，片源还特别全。最近在追的几部剧这里都有高清版，播放也很流畅，强烈推荐给身边的朋友了！',
    source: '久久视频专区',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20minimalist%20abstract%20portrait%20visual%20with%20soft%20coral%20and%20gold%20shapes%2C%20modern%20clean%20design%2C%20user%20profile%20style&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '追剧达人阿琳',
    time: '5天前',
    content: '找了好久97视频的老剧资源，没想到苹果视频这里全都有，而且是高清修复版！画质比我想象的好太多了，每天下班回家就打开看两集，太惬意了。',
    source: '97视频专区',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20minimalist%20abstract%20portrait%20visual%20with%20soft%20amber%20and%20coral%20shapes%2C%20modern%20clean%20design%2C%20profile%20avatar%20aesthetic&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '电影发烧友大刘',
    time: '1周前',
    content: '作为一个阅片无数的老影迷，苹果视频的片源质量让我很惊喜。芒果视频和丝瓜视频的热门内容这里都有收录，而且分类清晰，找片很方便。关键是0广告，纯净观影体验太棒了。',
    source: '芒果视频专区',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-950 mb-3">
            用户评价
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            听听真实用户怎么说苹果视频
          </p>
        </div>
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
          {comments.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-white border border-background-200/70 p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-950">
                    {item.name}
                  </div>
                  <div className="text-xs text-foreground-400">
                    {item.time} · {item.source}
                  </div>
                </div>
              </div>
              <div className="flex text-accent-500 mb-2 text-sm">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}